<template>
  <div>
    <div
      class="page_container goodsManageSet"
      v-loading="loading"
      element-loading-text="请稍后"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.5)"
    >
      <div class="breadcrumb flex-rowl">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/manage' }"
            >SKU管理</el-breadcrumb-item
          >
          <el-breadcrumb-item :to="{ path: '/commondityIndex/cManageIndex' }"
            >商品管理</el-breadcrumb-item
          >
          <el-breadcrumb-item
            :to="{ path: '/commondityIndex/cManageEdit/cProductionCode' }"
            >商品生产组码管理</el-breadcrumb-item
          >
          <el-breadcrumb-item>商品生产组码设置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="form_container">
        <h1>商品生产组码设置</h1>
        <div class="content_wrap">
          <div class="form_wrap">
            <div class="block">
              <p>属性标签&属性标签值</p>
              <div
                class="shop_attr_column"
                v-for="(item, index) in shopAttr"
                :key="index"
              >
                <div class="title">{{ item.attrname }}</div>
                <div class="select_list flex-rowl">
                  <div
                    v-for="(itemChild, indexChild) in item.items"
                    :key="indexChild"
                    @click="handleSelectAttr(itemChild)"
                    class="select_item flex-between"
                    :class="formData.attrid == itemChild.id ? 'active' : ''"
                  >
                    <span class="txt">{{ itemChild.attrvalue }}</span>
                    <span
                      v-if="formData.attrid == itemChild.id"
                      class="iconfont icon-3tuihuanhuozhengcegouxuan"
                    ></span>
                  </div>
                </div>
              </div>
              <!-- <div class="select_box">
                <el-select
                  v-model="formData.attrid"
                  placeholder="请选择属性标签&属性标签值"
                >
                  <el-option
                    v-for="item in attrList"
                    :key="item.id"
                    :label="item.msg"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div> -->
            </div>
            <div class="block">
              <p>生产商</p>
              <div class="select_box">
                <el-select
                  v-model="formData.productid"
                  placeholder="请选择生产商"
                >
                  <el-option
                    v-for="item in supplierList"
                    :key="item.id"
                    :label="item.labelname"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>

            <div class="block">
              <p><span class="mark">*</span>投产时间</p>
              <div class="input_box">
                <el-date-picker
                  v-model="formData.startdate"
                  type="datetime"
                  placeholder="请选择投产时间"
                  default-time="12:00:00"
                  value-format="yyyy-MM-dd HH:mm:ss"
                >
                </el-date-picker>
              </div>
            </div>

            <div class="block">
              <p><span class="mark">*</span>预期生产数量</p>
              <div class="input_box">
                <el-input
                  v-model="formData.plannum"
                  placeholder="请输入预期生产数量"
                ></el-input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form_footer flex-rowl">
        <div class="btn" @click="query">确认</div>
        <div class="return_txt" @click="handleReturn">←返回</div>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import {
  getCommondityLabelList,
  encryptstringview,
  getSupplierList,
  getCommidityDetail,
} from "../../../api/api";
import {
  editShopProductionCode,
  addShopProductionCode,
  getShopProductionCodeDetail,
} from "../../../api/shop";
export default {
  name: "cProductionCodeSet",
  data() {
    return {
      loading: false,
      attrList: [], // 属性列表

      id: "", // 属性id
      labelNum: "", // 商品价格
      labeltype: "", // 商品类型
      formData: {
        cmid: "",
        id: "",
        sku: "",
        attrid: "",
        productid: "",
        startdate: "",
        plannum: "",
      },
      creenIndex: "",
      dialogImageUrl: "",
      dialogVisible: false,

      supplierParams: {
        qyid: 0,
        Page: 1,
        PageSize: 50,
        keyword: "",
      },
      supplierList: [],
      shopAttr: [],
    };
  },
  created() {
    let { routerList, OPENID, USERINFO } = this.$store.state;
    if (USERINFO.qy) {
      this.supplierParams.qyid = USERINFO.qy.id;
    } else {
      this.supplierParams.qyid = 0;
    }
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { cmid, id } = JSON.parse(res.jsondata);
        this.formData.cmid = cmid;
        this.formData.id = id;
        if (id) {
          this.getShopProductionCodeDetail();
        }
        this.getCommidityDetail(cmid);
        this.getAtrrList(cmid);
        this.getSupplierList();
      } else {
        this.$router.back();
      }
    },

    // 获取商品详情
    getCommidityDetail(id) {
      getCommidityDetail({ id }).then((res) => {
        this.formData.sku = res.sku;
        this.shopAttr = res.attr;
      });
    },

    getShopProductionCodeDetail() {
      this.loading = true;
      let { id } = this.formData;
      getShopProductionCodeDetail({ id }).then((res) => {
        // this.formData = res;
        let splitStartdate = res.startdate.split("T");
        this.formData.attrid = res.attrid;
        this.formData.productid = res.productid;
        this.formData.startdate = splitStartdate[0] + " " + splitStartdate[1];
        this.formData.plannum = res.plannum;
        this.loading = false;
      });
    },

    // 获取属性标签
    getAtrrList(cmid) {
      let params = {
        cmid,
        keyword: "",
      };
      getCommondityLabelList(params).then((res) => {
        res.forEach((v) => {
          v.msg = v.attrname + " " + v.attrvalue;
        });
        this.attrList = res;
      });
    },
    // 操作商品的属性
    handleSelectAttr(itemChild) {
      this.formData.attrid = itemChild.id
    },

    // 获取生厂商
    getSupplierList() {
      let { supplierParams } = this;
      getSupplierList(supplierParams).then((res) => {
        // 按时间降序
        // dataNew.sort((a, b) => b.createdate.localeCompare(a.createdate))
        let newRes = res.filter((v) => v.labelstate == 1);
        this.supplierList = newRes;
      });
    },

    handleReturn() {
      history.back();
    },

    // 输入框限制
    handleInput(event) {
      // 只允许输入数字和小数点
      let value = event.replace(/[^\d.]/g, "");
      // 限制只能输入一个小数点
      value = value.replace(/^\./, "").replace(/\.{2,}/g, ".");
      // 截取小数点后两位
      value = value.replace(/^(-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
      this.formData.num = value;
    },

    query() {
      let { formData } = this;
      // formData.pic = this.imgSplit(formData.pic);
      let params = formData;
      if (formData.startdate == "") {
        this.$message.warning("请选择投产时间");
        return false;
      }
      if (formData.plannum == "") {
        this.$message.warning("请填写预期生产数量");
        return false;
      }
      this.loading = true;
      if (formData.id != "") {
        editShopProductionCode(params).then((res) => {
          let data = res;
          if (data.result) {
            this.loading = false;
            this.$message.success(data.message);
            // setTimeout(() => {
            //   this.loading = false;
            //   this.$router.back();
            // }, 500);
          } else {
            this.loading = false;
            this.$message.error(data.message || "服务器报错，请稍后～");
          }
        });
      } else {
        addShopProductionCode(params).then((res) => {
          let data = res;
          if (data.result) {
            this.$message.success(data.message);
            setTimeout(() => {
              this.loading = false;
              this.$router.back();
            }, 500);
          } else {
            this.loading = false;
            this.$message.error(data.message || "服务器报错，请稍后～");
          }
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  .shop_attr_column {
    margin: 20px 0 30px;
    .title {
      font-size: 14px;
      color: #3c3c3c;
      position: relative;
      padding-left: 10px;
      margin-bottom: 15px;
      &::before {
        position: absolute;
        width: 3px;
        height: 15px;
        top: 50%;
        transform: translateY(-50%);
        background: #ff0042;
        display: inline-block;
        content: "";
        left: -2px;
      }
    }
    .select_list {
      flex-wrap: wrap;
      .select_item {
        padding: 0 15px 0 17px;
        background: #f5f5f5;
        border-radius: 15px;
        font-size: 12px;
        color: #3c3c3c;
        margin: 0 10px 10px 0;
        position: relative;
        min-width: 125px;
        min-height: 45px;
        border: 2px solid #f5f5f5;
        box-sizing: border-box;
        cursor: pointer;
        height: 30px;
        border: 2px solid #fff;
        &.active {
          background: #fff;
          border: 2px solid #f5f5f5;
          box-sizing: border-box;
        }
        .icon-3tuihuanhuozhengcegouxuan {
          font-size: 24px;
          color: #ff0042;
        }
      }
    }
  }
}
</style>